import {
  AutomaticGroupComponent,
  CommunicationSizeComponent,
  ComponentIds,
  Entity,
  GuestConnectionsComponent,
  HierarchyUtils,
  Vector,
  WorldTransformComponent
} from '@inter-ikea-core/core';
import { CoreApi, ErrorMessages } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const dragAndDropDoorsBehavior = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const frameAtPosition = coreApi.entities.getEntityAtPosition(props.position, [
    ComponentIds.FRAME_COMPONENT_ID
  ]);
  const doors =
    frameAtPosition &&
    coreApi.entities
      .getFrameDescendants(frameAtPosition)
      .filter(entity => entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID));

  doors?.forEach(door => coreApi.entities.delete(door));

  const isCorner =
    frameAtPosition &&
    frameAtPosition.getComponent<GuestConnectionsComponent>(
      ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID
    )?.highestPriorityConnection?.guestConnector.key === 'wall-corner';
  if (isCorner) {
    coreApi.emit.onPlacementAttempt(ErrorMessages.BillyCornerFrameNoDoors);
  }

  const placementResult = coreApi.products.addCluster(props.coreProductIds, props.position);
  const placedEntity = placementResult.placedEntity;
  if (!placementResult.valid) {
    if (placementResult?.errors?.find(error => 'unfulfilledConnectors' in error)) {
      //If not possible to place new door undo potentiall delete of previous door
      coreApi.history.undo();
      coreApi.history.discardLatestSnapshot();
    }
  } else if (placedEntity) {
    // If placedEntity parent is an extension, we must look in the automaticGroup to find it
    const frame =
      getFramesInGroup(placedEntity, coreApi)?.[0] ?? HierarchyUtils.parent(placedEntity);
    if (!frame) return;

    const rightDoorPosition = placedEntity.getComponent<WorldTransformComponent>(
      ComponentIds.WORLD_TRANSFORM_COMPONENT_ID
    )?.transform.position;

    const frameSize = frame.getComponent<CommunicationSizeComponent>(
      ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
    )?.size;

    const addLeftDoor = frameSize?.width === 800;
    if (addLeftDoor) {
      const doorProduct = rootState.products.inMarket.find(
        product => product.coreProductId == props.coreProductId
      );

      const leftDoorProduct = rootState.products.inMarket.find(
        product =>
          product.globalItemNo === doorProduct?.globalItemNo &&
          product.coreProductId.includes('left')
      );
      if (leftDoorProduct?.coreProductId) {
        const leftDoorPosition = new Vector(
          (rightDoorPosition?.X ?? 0) - 40,
          rightDoorPosition?.Y ?? 0,
          0
        );

        const doorEntity = coreApi
          .getServices()
          .productManager.createEntity(leftDoorProduct.coreProductId);
        doorEntity && coreApi.placementService.snapToPosition(doorEntity, leftDoorPosition, false);
      }
    }
  }
  coreApi.toggleExhaustiveValidation(false);
  return placementResult;
};

export default dragAndDropDoorsBehavior;

const getFramesInGroup = (entity: Entity, coreApi: CoreApi) => {
  const parent = coreApi.entities.getParent(entity);
  const automaticGroup = parent?.getComponent<AutomaticGroupComponent>(
    ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID
  );

  const members = automaticGroup?.members;
  const framesInGroup = members?.filter(member =>
    member.hasComponent(ComponentIds.FRAME_COMPONENT_ID)
  );

  return framesInGroup;
};
